var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.currency,
      "error-messages": _vm.validationMessage,
      "item-text": "symbol",
      "item-value": "symbol",
      label: _vm.contextLabel,
      rules: _vm.rules,
      "menu-props": { "min-width": "90px" },
      readonly: _vm.readonly
    },
    model: {
      value: _vm.contextModel,
      callback: function($$v) {
        _vm.contextModel = $$v
      },
      expression: "contextModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }